/**
 * VK ID OAuth 配置（Web PKCE）
 * 前端仅需 REACT_APP_VK_APP_ID；Secure key / Service token 配置在后端。
 */

import packageJson from '../../package.json';

const BASE_PATH = process.env.PUBLIC_URL || "/mg";
const VK_ID_AUTHORIZE_URL =
  process.env.REACT_APP_VK_AUTHORIZE_URL || 'https://id.vk.ru/authorize';
const VK_SCOPE = process.env.REACT_APP_VK_SCOPE || 'vkid.personal_info email';

export const VK_CONFIG = {
  appId: process.env.REACT_APP_VK_APP_ID || packageJson.config?.vkAppId || '',
  scope: VK_SCOPE,
  getRedirectUri: () =>
    process.env.REACT_APP_VK_REDIRECT_URI ||
    `${window.location.origin}${BASE_PATH}/vk-callback`,
  getCallbackPath: () => `${BASE_PATH}/vk-callback`,
  buildAuthUrl: ({ state, codeChallenge }) => {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: String(VK_CONFIG.appId),
      redirect_uri: VK_CONFIG.getRedirectUri(),
      state,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      scope: VK_CONFIG.scope,
    });
    return `${VK_ID_AUTHORIZE_URL}?${params.toString()}`;
  },
};
